"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var FreeShippingThresholdText = function (_a) {
    var cartTotal = _a.cartTotal, threshold = _a.threshold;
    var hasFreeShipping = cartTotal >= threshold;
    if (hasFreeShipping) {
        return ((0, preact_1.h)("p", { class: "cart-section__review-threshold-text" }, "Congrats - You've unlocked free shipping!"));
    }
    var amountToFreeShipping = {
        amount: ((threshold - cartTotal) / 100).toFixed(2),
        currencyCode: 'USD',
    };
    return ((0, preact_1.h)("p", { class: "cart-section__review-threshold-text" },
        (0, preact_1.h)("span", { class: "cart-section__review-threshold-text--orange" }, "Free shipping"),
        " is only",
        ' ',
        (0, preact_1.h)("span", { class: "cart-section__review-threshold-remaining" }, (0, hydrogen_react_1.useMoney)(amountToFreeShipping).localizedString),
        ' ',
        "away"));
};
exports.default = FreeShippingThresholdText;
